export default __webpack_public_path__ + "static/media/settingsinbox.0802012b.svg";